// extracted by mini-css-extract-plugin
export default {"key_value":"key_value_key_value__Ky7lu","key_value_text":"key_value_key_value_text__t-mwX","key_input":"key_value_key_input__v649y","value_input":"key_value_value_input__r5AUs"};